

export const frontMatter = {
	sidebar_position: 8,
	license: 'republish',
	author: 'Jan van Steenbergen',
	origin: 'http://steen.free.fr/interslavic/syntax.html'
};
export const contentTitle = 'Синтаксис';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-i-18-n-bg-docusaurus-plugin-content-docs-current-learn-grammar-syntax-md-3b8.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    h1: "h1",
    header: "header",
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, TransliteratorElement} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!TransliteratorElement) _missingMdxReference("TransliteratorElement", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "синтаксис",
        children: "Синтаксис"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Словоредът е основно свободен, но предпочитаният (и стилистично най-неутрален) словоред е субект – глагол – обект (SVO). Не е задължително, но имайте предвид, че поставянето на обекта преди субекта няма да помогне за изясняване на значението. Това не е случаят с изреченията, в които личното местоимение или местоимението ", _jsx(TransliteratorElement, {
        children: "kto"
      }), " е подлог или обект, тъй като личните местоимения и ", _jsx(TransliteratorElement, {
        children: "kto"
      }), " имат свои собствени форми за винителен падеж, така че значението винаги е ясно."]
    }), "\n", _jsx(_components.p, {
      children: "Модификаторите обикновено предхождат съществителното. Това също не е задължително, но е най-неутралния и най-ясния начин за изграждане на изречение."
    }), "\n", _jsx(_components.p, {
      children: "Има два вида въпроси:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Да-не въпроси могат да бъдат зададени по три различни начина:", "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["или се различава от нормалното декларативно изречение само по интонация:", "\n", _jsxs(_components.ul, {
              children: ["\n", _jsxs(_components.li, {
                children: [_jsx(TransliteratorElement, {
                  children: "Otec kupil knigu?"
                }), " „Татко купил ли е книга?“"]
              }), "\n"]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["или това изречение се предхожда от частицата ", _jsx(TransliteratorElement, {
              children: "či"
            }), ":", "\n", _jsxs(_components.ul, {
              children: ["\n", _jsx(_components.li, {
                children: _jsx(TransliteratorElement, {
                  children: "Či otec kupil knigu?"
                })
              }), "\n"]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["или се маркира с въпросителна частица ", _jsx(TransliteratorElement, {
              children: "li"
            }), ", поставена точно след фокусната точка на въпроса, обикновено глагола:", "\n", _jsxs(_components.ul, {
              children: ["\n", _jsx(_components.li, {
                children: _jsx(TransliteratorElement, {
                  children: "Kupil li otec knigu?"
                })
              }), "\n"]
            }), "\n"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["Други въпроси започват с въпросително местоимение или наречие, поставено в началото на изречението:", "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Koju knigu kupil otec?"
            }), " „Коя книга е купил бащата?“"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Kde otec kupil tu knigu?"
            }), " „Откъде баща си купи тази книга?“\nВ този тип изречения значението обикновено се изяснява от използвания случай:"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Koja žena ljubi togo muža?"
            }), " „Коя жена обича този мъж?“ (жена = субект, мъж = обект)"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Koju ženu ljubi toj muž?"
            }), " „Коя жена обича този мъж?“ (мъж = субект, жена = обект)"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["Ако е необходимо, е възможно да се използват пасивни изречения, които винаги са ясни:", "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Koja žena jest ljubjena od togo muža?"
            }), " „Коя жена е обичана от този мъж?“"]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Заключителните клаузи се превеждат с помощта на ", _jsx(TransliteratorElement, {
        children: "že"
      }), " или ", _jsx(TransliteratorElement, {
        children: "da"
      }), ", последвани от условното условие:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "Turisti posětet Niderlandiju, že by fotografovali tulipany."
        }), " „Туристите посещават Холандия, за да правят снимки на лалетата.”"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "Turisti posětili Niderlandiju, že by fotografovali tulipany."
        }), " „Туристи посетиха Холандия, за да направят снимки на лалетата.”"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "Ona prinosi jabloka, da by děti byli zdrave."
        }), " „Тя носи ябълки, за да са здрави децата.”"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "Ona prinosila jabloka, da by děti byli zdrave."
        }), " „Тя донесе ябълки, за да са здрави децата.”"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Страдателният залог може да се използва, но ако е така, трябва да се прави с повишено внимание. Изречение като: ", _jsx(TransliteratorElement, {
        children: "Pica je dělana"
      }), " или ", _jsx(TransliteratorElement, {
        children: "Pica je dělajema"
      }), " „Пица се прави” е граматически напълно правилно. Все пак е по-добре да се избегне, защото подобна конструкция звучи тромаво за онези славяни, които не са свикнали да използват често глагола „да бъдеш“, особено в сегашно време. Освен това, докато е напълно естествено за част от говорещите славянски език, за други миналото страдателно причастие изобщо не може да се използва за конструкция за сегашно време. Следователно, ако темата е известна, по-добре е да се използва нормално активно изречение. И ако субектът не е известен, както в случая с нашата пица, е възможно да се използва форма на трето лице множествено число без субект: ", _jsx(TransliteratorElement, {
        children: "Dělajut picu"
      }), " „Те правят пица, един прави пица, пица се прави”. Още по-разпространена е рефлексивната конструкция: ", _jsx(TransliteratorElement, {
        children: "Pica dělaje se"
      }), ", което буквално означава „Пицата се прави сама” и трябва да се преведе като „Човек прави пица, пицата се прави”."]
    }), "\n", "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

